<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Contabili
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col cols="2">
          <v-switch
            v-model="soloNonSaldati"
            label="Solo Non Saldati"
            class="ml-4"
            inset
            hide-details
          ></v-switch
        ></v-col>
        <v-col cols="2">
          <v-switch
            v-model="raggruppaPerCliente"
            label="Raggruppa per cliente"
            class="ml-4"
            inset
            hide-details
          ></v-switch>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            v-model="cliente"
            :items="clienti"
            label="Cliente"
            item-text="nome"
            item-value="iva"
            outlined
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-select
            v-model="periodo"
            :items="periodoItems"
            label="Periodo"
            item-text="nome"
            item-value="value"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
            v-model="tipo"
            :items="tipoItems"
            label="Tipo"
            item-text="nome"
            item-value="value"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-switch
            v-model="filtraPerDdt"
            label="Filtra per DDT"
            class="ml-4 mt-n2"
            inset
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
      <v-row no-gutters class="mt-4">
        <v-col cols="2"> Cliente </v-col>
        <v-col cols="2"> Data </v-col>
        <v-col cols="1"> Importo </v-col>
        <v-col cols="1"> DDT # </v-col>
        <v-col cols="1"> Conteggio </v-col>
        
        <v-col cols="1"> Ordine # </v-col>
        <v-col cols="1"> Saldato </v-col>
        <v-col cols="3"> Note </v-col>
      </v-row>
      <v-divider class="mt-4 mb-6"></v-divider>
      <template v-if="filtraPerDdt">
        <template v-for="contabile in filterByDdt">
          <v-lazy :options="{ threshold: 0.7 }" :key="contabile.id">
            <contabile
              @new_insert="refreshList"
              :contabile="contabile"
            ></contabile>
          </v-lazy>
        </template>
      </template>
      <template v-else>
        <template v-if="raggruppaPerCliente">
          <div v-for="(group, cliente) in groupedByCliente" :key="cliente">
            <v-row class="mb-1" align="center">
              <v-col cols="auto" class="font-weight-bold">{{
                getCliente(cliente).nome
              }}</v-col>
              <v-col cols="auto">
                <v-btn icon small @click="stampaEstrattoContoCliente(cliente)" title="Stampa estratto conto">
                  <v-icon small>mdi-file-pdf-box</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div v-for="(monthGroup, month) in group.contabili" :key="month">
              <v-row class="mb">
                <v-col cols="12" class="font-weight-light"
                  ><u>{{ month }}</u></v-col
                >
              </v-row>
              <template v-for="contabile in monthGroup.contabili">
                <v-lazy :options="{ threshold: 0.7 }" :key="contabile.id">
                  <contabile
                    @new_insert="refreshList"
                    :contabile="contabile"
                  ></contabile>
                </v-lazy>
              </template>
              <v-row no-gutters class="mt-2">
                <v-col cols="4" offset="4">
                  Tot Mese: € {{ monthGroup.totale.toFixed(2) }}
                  <span class="green--text mx-2">
                    € {{ monthGroup.tot_verde.toFixed(2) }}</span
                  >
                  <span class="blue--text">
                    € {{ monthGroup.tot_blu.toFixed(2) }}</span
                  >
                </v-col>
              </v-row>
            </div>
            <v-row no-gutters class="mt-4">
              <v-col cols="3" offset="4">
                <b>Totale: € {{ group.totale.toFixed(2) }}</b>
                <span class="green--text mx-2">
                  € {{ group.tot_verde.toFixed(2) }}</span
                >
                <span class="blue--text">
                  € {{ group.tot_blu.toFixed(2) }}</span
                >
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-6"></v-divider>
          </div>
        </template>
        <template v-else>
          <div v-for="(group, day) in groupedByDay" :key="day">
            <v-row class="mb-1">
              <v-col cols="12" class="font-weight-bold">{{ day }}</v-col>
            </v-row>
            <template v-for="contabile in group.contabili">
              <v-lazy :options="{ threshold: 0.5 }" :key="contabile.id">
                <contabile
                  @new_insert="refreshList"
                  :key="contabile.id"
                  :contabile="contabile"
                ></contabile>
              </v-lazy>
            </template>
            <v-row no-gutters class="">
              <v-col cols="3" offset="4">
                <v-divider class="mb-2" />
                <b>{{ soloNonSaldati ? 'Tot. non saldati' : 'Totale' }}: € {{ group.totale.toFixed(2) }}</b>
                <span class="green--text mx-2"
                  >€ {{ group.tot_verde.toFixed(2) }}</span
                >
                <span class="blue--text">€ {{ group.tot_blu.toFixed(2) }}</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-6"></v-divider>
          </div>
        </template>
      </template>
      <template v-if="contabili.length == 0">
        <v-row no-gutters>
          <v-col cols="12" class="text-center">
            Nessun Pagamento Registrato
          </v-col>
        </v-row>
      </template>
    </v-card-text>
    <v-btn fab fixed bottom right color="green" class="ma-12" @click="$refs.nuova_contabile.open()">
      <v-icon color="white">mdi-plus</v-icon>
    </v-btn>
    <nuova_contabile
      noButton
      ref="nuova_contabile"
      @new_insert="refreshList"
    ></nuova_contabile>
    <v-dialog v-model="dialogInattivita" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Inattività</v-card-title>
        <v-card-text
          >Sei ancora lì? Premi il pulsante per continuare.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="continua_navigazione"
            >Continua</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import nuova_contabile from "./nuova_contabile.vue";
import contabile from "./contabile_desktop_element.vue";
import contabile_main_mixin from "../mixin/contabili_main_mixin";
export default {
  components: {
    nuova_contabile,
    contabile,
  },
  mixins: [contabile_main_mixin],
};
</script>